export default {
    setSignupStep({ commit }, step) {
      commit("SIGNUP_STEP_SET", step);
    },
  }